import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});
export const figure29 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      height: 350,
      type: 'pie',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
  },
  colors: ['#5b9bd6', '#ffc000', '#ed7d31', '#a5a5a5'],
  credits: {
      enabled: false
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },

  plotOptions: {
      series: {
          colorByPoint: true,
          borderWidth: 0
      },
      pie: {
          dataLabels: {
              format: '{point.name} <br /> {point.percentage:.0f}',
              distance: -50,
              enabled: true
          }
      }
  },

  exporting: {
      enabled: false
  },
  tooltip: {
      headerFormat: '<h5 style="font-size:18px; font-weight: normal;">{point.key}</h5>',
      pointFormat: '<b>{point.percentage}%</b>',
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
          padding: 0
      },
      formatter: function () {
          return this.point.name + ': <b>' + Highcharts.numberFormat(this.percentage, 0) + '%</b>';
      },
  },
  accessibility: {
      point: {
          valueSuffix: '%'
      }
  },

  series: [{
      size: 260,
      startAngle: 20,
      center: [200, 130],
      data: [{
          name: "Conocido", y: 37.83, custom: '2674', color: '#ffc000'
        }, {
          name: "Desconocido", y: 62.17, custom: '4394', color: '#5b9bd6'
        }
      ],
  },{
      size: 200,
      center: [600, 130],
      startAngle: 60,
      data: [
          {
              name: "Sin riesgo", y: 30.03, custom: '', color: '#a5a5a5'
            },
          {
          name: "En riesgo", y: 69.94, custom: '', color: '#ed7d31'
        }
      ],
  }]
}
